export default __webpack_public_path__ + "static/media/MS-team-configure-popup-bg.f51a293d.svg";